import * as requests from './requests'
import constants from './constants'
import urls from './urls'

// Mail Template

export async function getMailTemplateList() {
  return requests
    .get(constants.API_URL_TEMPLATE, urls.GET_MAIL_TEMPLATE_BY_ID)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getMailTemplateById(payload) {
  return requests
    .get(constants.API_URL_TEMPLATE, `${urls.GET_MAIL_TEMPLATE_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateMailTemplate(payload) {
  return requests
    .put(constants.API_URL_TEMPLATE, urls.PUT_MAIL_TEMPLATE_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertMailTemplate(payload) {
  return requests
    .post(constants.API_URL_TEMPLATE, urls.PUT_MAIL_TEMPLATE_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteMailObservaciones(payload) {
  return requests
    .remove(constants.API_URL_TEMPLATE, `${urls.DELETE_MAIL_TEMPLATE_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}
